import React from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from 'config';
import {
  HeaderAuth,
  HeaderContextWrapper,
  HeaderMain,
} from 'view/molecules/HeaderComponents';
import * as S from './Header.styles';

export const Header = () => {
  const { pathname } = useLocation();
  const isLoggedIn = pathname !== ROUTES.location && pathname !== ROUTES.login;

  return (
    <S.HeaderStyled>
      {isLoggedIn ? (
        <HeaderContextWrapper>
          <HeaderMain />
        </HeaderContextWrapper>
      ) : (
        <HeaderAuth />
      )}
    </S.HeaderStyled>
  );
};
